import 'react-app-polyfill/stable'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { MsalProvider } from '@azure/msal-react'
import { ConnectedRouter } from 'connected-react-router'

import store from './store'
import App from './containers/App/App'
import history from './config/history'
import { msalInstance } from './msalClient'

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
